import React from "react";
import axios from "axios";
import moment from "moment";
import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardText,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup,
  Alert
} from "reactstrap";
import {
  Textbox,
  Checkbox,
  Textarea,
  Select as Select1,
  Radiobox,
} from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import ValoresCotizacion from "./ValoresCotizacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import DatePicker, { registerLocale } from "react-datepicker";
import {
  setDatosPagador,
  setDatosFacturacion,
  FetchGuardarDatosFacturacion,
  FetchDescargarCotizacion,
  obtenerDatosFetch,
} from "../../redux/actions/aCotizacion";
import { runInNewContext } from "vm";
import { ambienteAplicacion, urlPlaceToPayKm } from "../../constants/urls";
import { estaEnListaNegra, FetchDataProductosCarrito, LimpiarListaNegra } from "../../redux/actions/ACarritoProductos";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import { consolidateStreamedStyles } from "styled-components";
import { ErrorMsgConstants, expresionesRegulares, infoIds } from "../../constants";
import { ramos } from "../../utils/constants";
const listadoPersoneria = [
  { id: 0, name: "Seleccione la personería" },
  { id: 1, name: "Natural" },
  { id: 2, name: "Jurídica" },
];

const isFechaValidaStr = (fecha, defaultValue = new Date(), formato = "DD/MM/yyyy") => {
  if (typeof fecha === "string") {
    const momentDate = moment(fecha, formato);
    if (momentDate.isValid()) {
      return momentDate.toDate();
    }
    if (defaultValue) {
      return defaultValue
    }
    throw new Error("Fecha invalida");
  }
  const momentDate = moment(fecha);
  if (momentDate.isValid()) {
    return fecha;
  }
  if (defaultValue) {
    return defaultValue
  }
  throw new Error("fecha invalida")
}

class Cotizacion4Cotizacion extends React.Component {
  constructor(props) {
    super(props);
    var today = new Date();
    var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    if (
      this.props.datosCotizacion.datosPagador !== "" &&
      this.props.datosCotizacion.datosPagador !== undefined &&
      this.props.datosCotizacion.datosPagador !== null
    ) {
      let fechaNacimiento = this.props.datosCotizacion.datosPagador
        .cliFechaNacimiento;
      if (fechaNacimiento !== undefined && fechaNacimiento !== null) {
        fechaNacimiento = fechaNacimiento.split("/", 3);
        //console.log("NACIMIENTO ", fechaNacimiento)
        firstDayOfMonth = new Date(
          fechaNacimiento[2],
          fechaNacimiento[1],
          fechaNacimiento[0]
        );
      }
    } else {
    }
    this.state = {
      desactivarBoton: false,
      esPasaporte: false,
      cargarDatosAsegurado: true,
      esPasaporteF: false,
      esruc: false,
      esrucf: false,
      placa: "",
      validate: false,
      hasPersoneriaError: true,
      hasCedulaError: true,
      hasCodTipoDocError: true,
      hasNombreError: true,
      hasApellidoError: true,
      hasCorreoError: true,
      hasDireccionError: true,
      hasCelularError: true,
      hasECivilError: true,
      hasGeneroError: true,
      hasProvinciaError: true,
      hasCiudadError: true,

      hasPersoneriaFError: true,
      hasCedulaFError: true,
      hasCodTipoDocFError: true,
      hasNombreFError: true,
      hasApellidoFError: true,
      hasCorreoFError: true,
      hasDireccionFError: true,
      hasCelularFError: true,
      hasECivilFError: true,
      hasGeneroFError: true,
      hasProvinciaFError: true,
      hasCiudadFError: true,

      mismosDatos: true,
      datosPagador: {
        cliPersoneria:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliPersoneria,
        cedula:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliIdentificacion,
        codTipodocumento:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodigoTipoDocumento,
        cliNombres:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliNombres,
        cliApellidos:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliApellidos,
        correo:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliEmail,
        direccion:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliDireccion,
        celular:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCelular,
        codEstadoCivil:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? null
            : this.props.datosCotizacion.datosPagador.cliCodigoEstadoCivil,
        codGenero:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodGenero,
        codProvincia:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodigoProvincia,
        codCiudad:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodigoCiudad,
        fechaNacimiento:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? firstDayOfMonth
            : firstDayOfMonth,
      },
      datosFacturacion: {
        cliPersoneria:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliPersoneria,
        cedula:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliIdentificacion,
        codTipodocumento:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodigoTipoDocumento,
        cliNombres:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliNombres,
        cliApellidos:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliApellidos,
        correo:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliEmail,
        direccion:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliDireccion,
        celular:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCelular,
        codEstadoCivil:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodigoEstadoCivil,
        codGenero:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodGenero,
        codProvincia:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodigoProvincia,
        codCiudad:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? ""
            : this.props.datosCotizacion.datosPagador.cliCodigoCiudad,
        fechaNacimiento:
          this.props.datosCotizacion.datosPagador === "" ||
            this.props.datosCotizacion.datosPagador === undefined
            ? firstDayOfMonth
            : firstDayOfMonth,
      },
      //agregado para truco persona natural ruc
      personeriaContratanteSeleccionadoUsuario: "",
      personeriaFacturacionSeleccionadoUsuario: "",

      //ver personeria
      $mostrarPersoneria: false,
      $mostrarPersoneriaF: false
    };
    this.validateForm = this.validateForm.bind(this);
    this.onClickRegresar = this.onClickRegresar.bind(this);
  }

  async onClickRegresar(e) {
    e.preventDefault();
    let carDescripcionSeguro = this.props.datosCarrito.productosCarrito
      .carDescripcionSeguro;
    if (carDescripcionSeguro == 'AIG AUTO') {
      carDescripcionSeguro = 'comparador'
    }
    if (carDescripcionSeguro == 'KilometroPaquete') {
      carDescripcionSeguro = 'vehiculosKilometrosPaquete'
    }
    this.props.history.push({
      pathname: "/resumen-cotizacion",
      search:
        `?id=${this.props.datosCarrito.productosCarrito.idCarrito !== undefined
          ? this.props.datosCarrito.productosCarrito.idCarrito
          : null
        }&paso=resumen` +
        (carDescripcionSeguro !== undefined && carDescripcionSeguro != null
          ? "&codigoProductoEspecial=" + carDescripcionSeguro
          : ""),
    });
  }

  toggleValidating(validate) {
    //console.log('000000000000000000000000000000000000000000000000000000000000')
    //console.log(validate)
    this.setState({ validate });
  }
  onClickPagar = (event) => { };
  componentDidMount() {
    this.props.limpiarDatosListaNegra()
    console.log("Cotizacion4COnfirmacion", this.props);



    if (this.props.datosCarrito && this.props.datosCarrito.productosCarrito && this.props.datosCarrito.productosCarrito.carDatosPagadorFacturacion) {
      this.props.history.push({
        pathname: "/forma-pago",
        search: `?id=${this.props.datosCarrito.productosCarrito.idCarrito}`,
      });

    }


  }

  getTipoDocumentos(personeria) {
    const listadoTipoDocumentos = [
      { id: 0, name: "Seleccione el tipo de documento", personeria: 3 },
      { id: infoIds.codigoCedulaNum, name: "Cédula", personeria: 1 },
      { id: infoIds.codigoRucNum, name: "Ruc", personeria: 2 },
      { id: infoIds.codigoPasaporteNum, name: "Pasaporte", personeria: 1 },
      //{ id: 3, name: "Ruc", personeria: 1 }, //agregado para pruebas
    ];
    // let listado = listadoTipoDocumentos.filter(
    //   (tipo) =>
    //     parseInt(tipo.personeria) === parseInt(personeria) ||
    //     parseInt(tipo.personeria) === 3
    // );
    console.log('listadoTipoDocumentos', listadoTipoDocumentos);
    return listadoTipoDocumentos;
  }

  handleChangeDate = (date) => {
    let { datosPagador } = this.state;
    datosPagador.fechaNacimiento = date;
    this.setState({
      datosPagador,
    });
  };
  handleChangeDateFacturacion = (date) => {
    let { datosFacturacion } = this.state;
    datosFacturacion.fechaNacimiento = date;
    this.setState({
      datosFacturacion,
    });
  };
  handleChangeFechaExpedicionPasaporte = (date) => {
    let { datosPagador } = this.state;
    datosPagador.fechaEmisionPasaporte = date;
    this.setState({
      datosPagador,
    });
  };
  handleChangeFechaVencimientoPasaporte = (date) => {
    let { datosPagador } = this.state;
    datosPagador.fechaCaducidadPasaporte = date;
    this.setState({
      datosPagador,
    });
  };
  handleChangeFechaIngresoPais = (date) => {
    let { datosPagador } = this.state;
    datosPagador.fechaIngresoPais = date;
    this.setState({
      datosPagador,
    });
  };
  handleChangeFechaExpedicionPasaporteF = (date) => {
    let { datosFacturacion } = this.state;
    datosFacturacion.fechaEmisionPasaporte = date;
    this.setState({
      datosFacturacion,
    });
  };
  handleChangeFechaVencimientoPasaporteF = (date) => {
    let { datosFacturacion } = this.state;
    datosFacturacion.fechaCaducidadPasaporte = date;
    this.setState({
      datosFacturacion,
    });
  };
  handleChangeFechaIngresoPaisF = (date) => {
    let { datosFacturacion } = this.state;
    datosFacturacion.fechaIngresoPais = date;
    this.setState({
      datosFacturacion,
    });
  };

  modificarStateFechas = (dataAux) => {
    dataAux.fechaNacimiento = `${dataAux.fechaNacimiento !== null
      ? this.cambiarFechaaString(dataAux.fechaNacimiento)
      : null
      }`;
    dataAux.fechaEmisionPasaporte = `${dataAux.fechaEmisionPasaporte !== null
      ? this.cambiarFechaaString(dataAux.fechaEmisionPasaporte)
      : null
      }`;
    dataAux.fechaIngresoPais = `${dataAux.fechaIngresoPais !== null
      ? this.cambiarFechaaString(dataAux.fechaIngresoPais)
      : null
      }`;
    dataAux.fechaCaducidadPasaporte = `${dataAux.fechaCaducidadPasaporte !== null
      ? this.cambiarFechaaString(dataAux.fechaCaducidadPasaporte)
      : null
      }`;

    return dataAux;
  };

  cambiarStringaFecha = (valor) => {
    if (typeof valor === "string") {
      let fecha = valor.slice(0, 10).split("/", 3);
      if (fecha.length === 3)
        return new Date(fecha[2], parseInt(fecha[1]) - 1, fecha[0]);
      else return null;
    }
    return valor;
  };

  cambiarFechaaString = (valor) => {

    if (valor !== null && valor !== undefined && typeof valor != 'string') {
      let fecha = valor;
      fecha = fecha.toISOString().slice(0, 10).replace(/-/g, "/");
      const array = fecha.split("/");
      return `${array[2]}/${array[1]}/${array[0]}`;
    } else {
      return valor;
    }

  };
  async validateForm(e) {
   // this.setState({ desactivarBoton: true })
    e.preventDefault();
    this.toggleValidating(true);
    //console.log(this.state.datosFacturacion,this.state.datosPagador)
    const {
      hasPersoneriaError,
      hasCedulaError,
      hasCodTipoDocError,
      hasNombreError,
      hasApellidoError,
      hasCorreoError,
      hasDireccionError,
      hasCelularError,
      hasECivilError,
      hasGeneroError,
      hasProvinciaError,
      hasCiudadError,
      hasPersoneriaFError,
      hasCedulaFError,
      hasCodTipoDocFError,
      hasNombreFError,
      hasApellidoFError,
      hasCorreoFError,
      hasDireccionFError,
      hasCelularFError,
      hasECivilFError,
      hasGeneroFError,
      hasProvinciaFError,
      hasCiudadFError,
      datosPagador,
      datosFacturacion,
      mismosDatos,
      esruc,
      esrucf,
      esPasaporte,
      esPasaporteF,
    } = this.state;



    datosPagador.cliApellidos = datosPagador.codTipodocumento == '2' ? '' : datosPagador.cliApellidos.trim()
    datosPagador.direccion = datosPagador.direccion.trim()
    datosPagador.cliNombres = datosPagador.cliNombres.trim()

    datosFacturacion.cliApellidos = datosFacturacion.codTipodocumento == '2' ? '' : datosFacturacion.cliApellidos.trim()
    datosFacturacion.direccion = datosFacturacion.direccion.trim()
    datosFacturacion.cliNombres = datosFacturacion.cliNombres.trim()

    let datosAuxP = {};
    let datosAuxF = {};



    let valApellido = hasApellidoError;
    let valGenero = hasGeneroError;
    let valEcivil = hasECivilError;
    let valApellidoF = hasApellidoFError;
    let valGeneroF = hasGeneroFError;
    let valEcivilF = hasECivilFError;
    if (esruc === true) {
      valApellido = false;
      valGenero = false;
      valEcivil = false;
    }
    if (esrucf === true) {
      valApellidoF = false;
      valGeneroF = false;
      valEcivilF = false;
    }

    let valCelular = true;
    let valMail = true;

    if (
      datosPagador.celular.indexOf("-") > 0 ||
      datosPagador.celular.indexOf(";") > 0 ||
      datosPagador.celular.indexOf(",") > 0 ||
      datosPagador.celular.indexOf(".") > 0
    ) {
      valCelular = false;
    }
    if (
      datosPagador.correo === "" ||
      datosPagador.correo === undefined ||
      datosPagador.correo === " " ||
      datosPagador.correo === null
    ) {
      valMail = false;
    }

    //validar Datos de Pagador
    if (
      !hasPersoneriaError &&
      !hasCedulaError &&
      !hasCodTipoDocError &&
      !hasNombreError &&
      !valApellido &&
      !hasCorreoError &&
      !hasDireccionError &&
      !hasCelularError &&
      !valEcivil &&
      !valGenero &&
      !hasProvinciaError &&
      !hasCiudadError &&
      valCelular &&
      valMail
    ) {
      let valCelularFE = true;
      let valMailFE = true;

      if (
        datosFacturacion.celular.indexOf("-") > 0 ||
        datosFacturacion.celular.indexOf(";") > 0 ||
        datosFacturacion.celular.indexOf(",") > 0 ||
        datosFacturacion.celular.indexOf(".") > 0
      ) {
        valCelularFE = false;
      }
      if (
        datosFacturacion.correo === "" ||
        datosFacturacion.correo === undefined ||
        datosFacturacion.correo === " " ||
        datosFacturacion.correo === null
      ) {
        valMailFE = false;
      }

      //ValidarDatosFacturacion



      console.log('testing2',
        !hasPersoneriaFError &&
        !hasCedulaFError &&
        !hasCodTipoDocFError &&
        !hasNombreFError &&
        !valApellidoF &&
        !hasCorreoFError &&
        !hasDireccionFError &&
        !hasCelularFError &&
        !valEcivilF &&
        !valGeneroF &&
        !hasProvinciaFError &&
        !hasCiudadFError &&
        valCelularFE &&
        valMailFE
      )
      if (!mismosDatos) {

        if (
          !hasPersoneriaFError &&
          !hasCedulaFError &&
          !hasCodTipoDocFError &&
          !hasNombreFError &&
          !valApellidoF &&
          !hasCorreoFError &&
          !hasDireccionFError &&
          !hasCelularFError &&
          !valEcivilF &&
          !valGeneroF &&
          !hasProvinciaFError &&
          !hasCiudadFError &&
          valCelularFE &&
          valMailFE
        ) {




          //Validaciones para Ruc
          if (
            datosPagador.codTipodocumento &&
            datosPagador.codTipodocumento === infoIds.codigoRucStr
          ) {
            datosPagador.cliPersoneria = "2";
          }
          if (
            datosFacturacion.codTipodocumento &&
            datosFacturacion.codTipodocumento === infoIds.codigoRucStr
          ) {
            datosFacturacion.cliPersoneria = "2";
          }

          //construir objeto para post

          datosAuxP = { ...datosPagador };
          datosAuxP = this.modificarStateFechas(datosAuxP);

          datosAuxF = { ...datosFacturacion };
          datosAuxF = this.modificarStateFechas(datosAuxF);



          const datosJSON = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            datosContratante: datosAuxP,
            datosPagadorFacturacion: datosAuxF,
            idCarrito: this.props.datosCarrito.productosCarrito.idCarrito,
            ambiente: ambienteAplicacion,
          };

          const  datosAsesor= {

            sucursalSeleccionada: this.props.datosSucursales
              .sucursalSelecionadaAsesor,
        
            ambiente: ambienteAplicacion,
            emailAsesor: this.props.dataUsuario.correo
              ? this.props.dataUsuario.correo
              : "",
              ramo: 'VH',
              codigoRamo:  ramos.VEHICULOS.codigo,

              codigoProducto: this.state.codigoProductoEspecial == "comparador" ? 6 : 4
          }
          



          // console.log("ENVIARRRR FACTURACION DATOS DIFERENTES", JSON.stringify(datosJSON))
          // console.log(this.state.datosPagador)
          //console.log("ENVIO GENERAR POLIZA 1")
          console.log('asesor', datosAsesor)
        
          await this.props.checkInListaNegra(datosPagador.cedula, datosAsesor)
         // await this.props.checkEmailValido(datosPagador.correo, datosPagador.cedula)

            if (this.props.datosListaNegra.inListaNegra === false) {

              await this.props.checkInListaNegra(datosFacturacion.cedula, datosAsesor)
              if (this.props.datosListaNegra.inListaNegra === false) {


                await this.props.guardarDatos(datosJSON);
                //console.log(this.state.datosPagador)
                if (!this.props.datosPago.guardarDatosHasError) {
                  console.log("this.propsnextfacturacion2", this.props);
                  let datosPago = this.props.datosPago.datosPagar;
                  //Agregar el codigo para redirifir en caso de que sea cliente o en caso que sea broker this.props.history
                  if (this.props.dataUsuario.usu_tipo_usuario === "cliente") {
                    //window.location.href = datosPago.url; //Comentado para agregar la pantalla de forma de pago
                    this.props.history.push({
                      pathname: "/forma-pago",
                      search: `?id=${this.props.datosCarrito.productosCarrito.idCarrito}`,
                    });
                  }
                  if (
                    this.props.dataUsuario.usu_tipo_usuario === "broker-user" ||
                    this.props.dataUsuario.usu_tipo_usuario === "admin-user" ||
                    this.props.dataUsuario.usu_tipo_usuario === "canal-user" ||
                    this.props.dataUsuario.usu_tipo_usuario === "asesor-user"
                  ) {
                    this.props.history.push({
                      //pathname: '/final-cotizacionbroker' //Comentado para implementar formas de pago
                      pathname: "/forma-pago",
                      search: `?id=${this.props.datosCarrito.productosCarrito.idCarrito}`,
                    });
                  }
                } else {
                  this.setState({ desactivarBoton: false })
                }


              } else {
                this.setState({ desactivarBoton: false })
              }



            } else {
              this.setState({ desactivarBoton: false })
            }


        

          // Descomentar para paso a produccion-------------------------------------------------

          // FIn Descomentar para paso a produccion-------------------------------------------------
          //          console.log('FAPASO11')
        } else {
          //console.log("Error facturacion")
          this.state({desactivarBoton: false})
        }
      } else {
        //cambiar formato de la fecha
        let datosPagadorEnviar = datosPagador;
        let fechaPagador = datosPagadorEnviar.fechaNacimiento;

        fechaPagador = fechaPagador
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "/");
        const answer_array = fechaPagador.split("/");
        datosPagadorEnviar.fechaNacimiento = `${answer_array[2]}/${answer_array[1]}/${answer_array[0]}`;

        let datosFacturacionEnviar = datosPagador;
        datosFacturacionEnviar.fechaNacimiento = `${answer_array[2]}/${answer_array[1]}/${answer_array[0]}`;
        //console.log("enviarrrrr", datosPagadorEnviar)

        //validar si el cliente seleccionado es un pasaporte


        //Validaciones para Ruc
        if (
          datosPagadorEnviar.codTipodocumento &&
          datosPagadorEnviar.codTipodocumento === infoIds.codigoRucStr
        ) {
          datosPagadorEnviar.cliPersoneria = "2";
        }
        if (
          datosFacturacionEnviar.codTipodocumento &&
          datosFacturacionEnviar.codTipodocumento === infoIds.codigoRucStr
        ) {
          datosFacturacionEnviar.cliPersoneria = "2";
        }

        datosAuxP = { ...datosPagadorEnviar };
        datosAuxP = this.modificarStateFechas(datosAuxP);

        datosAuxF = { ...datosFacturacionEnviar };
        datosAuxF = this.modificarStateFechas(datosAuxF);


        const datosJSON = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          datosContratante: datosAuxP,
          datosPagadorFacturacion: datosAuxF,
          idCarrito: this.props.datosCarrito.productosCarrito.idCarrito,
          ambiente: ambienteAplicacion,
        };
        console.log('dp2', datosPagador, datosFacturacionEnviar);
        // console.log("ENVIARRRR FACTURACION DATOS iguales", JSON.stringify(datosJSON))
        // console.log('---------------------------------------------------------------------')
        // console.log(this.state.datosPagador)
        // console.log("ENVIO GENERAR POLIZA 2")

        // Descomentar para paso a produccion-------------------------------------------------

        const  datosAsesor= {

          sucursalSeleccionada: this.props.datosSucursales
            .sucursalSelecionadaAsesor,
      
          ambiente: ambienteAplicacion,
          emailAsesor: this.props.dataUsuario.correo
            ? this.props.dataUsuario.correo
            : "",
            ramo: 'VH',
            codigoRamo:  ramos.VEHICULOS.codigo,
            codigoProducto: this.state.codigoProductoEspecial == "comparador" ? 6 : 4
        }

        await this.props.checkInListaNegra(datosPagador.cedula, datosAsesor)




          if (this.props.datosListaNegra.inListaNegra === false) {

            await this.props.guardarDatos(datosJSON);
            console.log('datos_PRESERVAR', new Intl.DateTimeFormat('en-GB').format(new Date(datosPagador.fechaNacimiento)));
            const datosPagadorPreservar = {
              cliNombres: datosPagador.cliNombres,
              cliApellidos: datosPagador.cliApellidos,
              cliCelular: datosPagador.celular,
              cliEmail: datosPagador.correo,
              cliTelefono: this.props.datosCotizacion.datosPagador, // el telefono registrado de antemeno, ya que en el formulario no se llena
              cliDireccion: datosPagador.direccion,
              cliIdentificacion: datosPagador.cedula,
              cliPersoneria: datosPagador.cliPersoneria,
              cliCodigoTipoDocumento: datosPagador.codTipodocumento,
              cliCodigoEstadoCivil: datosPagador.codEstadoCivil,
              cliCodGenero: datosPagador.codGenero,
              cliCodigoCiudad: datosPagador.codCiudad,
              cliCodigoProvincia: datosPagador.codProvincia,
              cliFechaNacimiento: new Intl.DateTimeFormat('en-GB').format(new Date(datosPagador.fechaNacimiento)) // dd/mm/yyyy
            }
            console.log('datos_PRESERVAR', datosPagadorPreservar);
            await this.props.setPagador(datosPagadorPreservar);
            // ------ termina guardado datos pagador

            //console.log(this.state.datosPagador)
            if (!this.props.datosPago.guardarDatosHasError) {
              console.log("this.props.nextGuardar", this.props);
              const carDescripcionSeguro = this.props.datosCarrito.productosCarrito
                .carDescripcionSeguro;
              console.log("carDescripcionSeguro", carDescripcionSeguro);
              if (
                carDescripcionSeguro != null &&
                carDescripcionSeguro != undefined &&
                carDescripcionSeguro === "KilometroConsumidos" &&
                this.props.dataUsuario.clienteFinal
              ) {
                const url =
                  urlPlaceToPayKm +
                  "&idCarrito=" +
                  this.props.datosCarrito.productosCarrito.idCarrito;
                window.location.href = url;
              } else {
                let datosPago = this.props.datosPago.datosPagar;
                if (this.props.dataUsuario.usu_tipo_usuario === "cliente") {
                  console.log("tipocliente");
                  if (
                    carDescripcionSeguro != null &&
                    carDescripcionSeguro != undefined &&
                    carDescripcionSeguro === "KilometroConsumidos"
                  ) {
                    this.props.history.push({
                      pathname: "/final-cotizacionbroker?ramo=VH ", //Agregado por formas de pago
                      search: "",
                    });
                  } else {
                    //window.location.href = datosPago.url;  //Comentado para agregar pantalla de seleccionar forma de pago
                    this.props.history.push({
                      pathname: "/forma-pago",
                      search: `?id=${this.props.datosCarrito.productosCarrito.idCarrito}`,
                    });
                  }
                }
                //if (this.props.dataUsuario.usu_tipo_usuario === "broker-user" || this.props.dataUsuario.usu_tipo_usuario === "admin-user" || this.props.dataUsuario.usu_tipo_usuario === "canal-user" || this.props.dataUsuario.usu_tipo_usuario === "asesor-user") {
                if (this.props.dataUsuario.usu_tipo_usuario !== "cliente") {
                  console.log("nocliente");
                  if (
                    carDescripcionSeguro != null &&
                    carDescripcionSeguro != undefined &&
                    carDescripcionSeguro === "KilometroConsumidos"
                  ) {
                    this.props.history.push({
                      pathname: "/final-cotizacionbroker", //Agregado por formas de pago
                      search: "?ramo=VH",
                    });
                  } else {
                    this.props.history.push({
                      //pathname: '/final-cotizacionbroker' //Comentado para implementar formas de pago
                      pathname: "/forma-pago", //Agregado por formas de pago
                      search: `?id=${this.props.datosCarrito.productosCarrito.idCarrito}`,
                    });
                  }
                }
              }
            }
            else {
              this.setState({ desactivarBoton: false })
            }


          }else {
            this.setState({ desactivarBoton: false })
          }


        // ------ Guardar copia adicional datos pagador

        //console.log('FAPASO2')
        // fin Descomentar para paso a produccion-------------------------------------------------
      }
    } else {
      this.setState({ desactivarBoton: false })
      // console.log("Error pagador", hasPersoneriaError,
      //   hasCedulaError,
      //   hasCodTipoDocError,
      //   hasNombreError,
      //   hasApellidoError,
      //   hasCorreoError,
      //   hasDireccionError,
      //   hasCelularError,
      //   hasECivilError,
      //   hasGeneroError,
      //   hasProvinciaError,
      //   hasCiudadError, datosPagador.correo)
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if (
      this.props.datosCotizacion.datosPagador !==
      prevProps.datosCotizacion.datosPagador
    ) {
      var today = new Date();
      var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      if (
        this.props.datosCotizacion.datosPagador !== "" &&
        this.props.datosCotizacion.datosPagador !== undefined &&
        this.props.datosCotizacion.datosPagador !== null
      ) {
        if (
          this.props.datosCotizacion.datosPagador.cliFechaNacimiento !== "" &&
          this.props.datosCotizacion.datosPagador.cliFechaNacimiento !==
          undefined &&
          this.props.datosCotizacion.datosPagador.cliFechaNacimiento !== null
        ) {
          let fechaNacimiento = this.props.datosCotizacion.datosPagador
            .cliFechaNacimiento;


          if (
            this.props.datosCotizacion.datosPersonaAsegurado &&
            this.props.datosCotizacion.datosPersonaAsegurado.fechaNacimientoAsegurado !== "" &&
            this.props.datosCotizacion.datosPersonaAsegurado.fechaNacimientoAsegurado !==
            undefined &&
            this.props.datosCotizacion.datosPersonaAsegurado.fechaNacimientoAsegurado !== null &&
            this.state.cargarDatosAsegurado
          ) {
            fechaNacimiento = this.props.datosCotizacion.datosPersonaAsegurado.fechaNacimientoAsegurado
          }

          if (fechaNacimiento !== undefined) {
            fechaNacimiento = fechaNacimiento.split("/", 3);

            firstDayOfMonth = new Date(
              fechaNacimiento[2],
              parseInt(fechaNacimiento[1]) - 1,
              fechaNacimiento[0]
            );
            //console.log("NACIMIENTO ", firstDayOfMonth)
          } else {
            //console.log("NACIMIENTO UNDEFINED", fechaNacimiento, firstDayOfMonth)
          }
        } else {
          //console.log("NACIMIENTO null", firstDayOfMonth)
        }

        //const anio=
      } else {
        //console.log("NACIMIENTO datosPagoadr", firstDayOfMonth)
      }
      let { datosPagador, datosPersonaAsegurado } = this.props.datosCotizacion;


      if (datosPersonaAsegurado && this.state.cargarDatosAsegurado) {
        datosPagador.cliIdentificacion = datosPersonaAsegurado.cedula

        let nombresYApellidos = datosPersonaAsegurado.nombre.split(" ");

        // Los dos primeros elementos de la lista son los apellidos y el último elemento es el nombre
        let apellidos = nombresYApellidos.slice(0, 2).join(" ");
        let nombre = nombresYApellidos.slice(2, 4).join(" ");

        datosPagador.cliNombres = nombre
        datosPagador.cliApellidos = apellidos
        datosPagador.cliCelular = datosPersonaAsegurado.celular

        datosPagador.cliCodGenero = datosPersonaAsegurado.codigoGenero
        datosPagador.cliCodigoEstadoCivil = parseInt(datosPersonaAsegurado.codigoEstadoCivil)
        datosPagador.cliCelular = datosPersonaAsegurado.celular
        datosPagador.cliCelular = datosPersonaAsegurado.celular

        this.setState({ cargarDatosAsegurado: false })




      }
      //console.log("imprimiendo fecha-------------------------------------------- ", this.props.datosCotizacion.datosPagador)

      this.setState({
        datosPagador: {
          cliPersoneria:
            datosPagador && datosPagador.cliPersoneria
              ? datosPagador.cliPersoneria
              : "",
          codTipodocumento:
            datosPagador && datosPagador.cliCodigoTipoDocumento
              ? datosPagador.cliCodigoTipoDocumento
              : "",
          cedula:
            datosPagador && datosPagador.cliIdentificacion
              ? datosPagador.cliIdentificacion
              : "",
          cliNombres:
            datosPagador && datosPagador.cliNombres
              ? datosPagador.cliNombres
              : "",
          cliApellidos:
            datosPagador && datosPagador.cliApellidos
              ? datosPagador.cliApellidos
              : "",
          correo:
            datosPagador && datosPagador.cliEmail ? datosPagador.cliEmail : "",
          direccion:
            datosPagador && datosPagador.cliDireccion
              ? datosPagador.cliDireccion
              : "",
          celular:
            datosPagador && datosPagador.cliCelular
              ? datosPagador.cliCelular
              : "",
          codEstadoCivil:
            datosPagador && datosPagador.cliCodigoEstadoCivil
              ? datosPagador.cliCodigoEstadoCivil
              : "",
          codGenero:
            datosPagador && datosPagador.cliCodGenero
              ? datosPagador.cliCodGenero
              : "",
          codProvincia:
            datosPagador && datosPagador.cliCodigoProvincia
              ? datosPagador.cliCodigoProvincia
              : "",
          codCiudad:
            datosPagador && datosPagador.cliCodigoCiudad
              ? datosPagador.cliCodigoCiudad
              : "",
          fechaNacimiento: firstDayOfMonth,
        },
        datosFacturacion: {
          cliPersoneria:
            datosPagador && datosPagador.cliPersoneria
              ? datosPagador.cliPersoneria
              : "",
          codTipodocumento:
            datosPagador && datosPagador.cliCodigoTipoDocumento
              ? datosPagador.cliCodigoTipoDocumento
              : "",
          cedula:
            datosPagador && datosPagador.cliIdentificacion
              ? datosPagador.cliIdentificacion
              : "",
          cliNombres:
            datosPagador && datosPagador.cliNombres
              ? datosPagador.cliNombres
              : "",
          cliApellidos:
            datosPagador && datosPagador.cliApellidos
              ? datosPagador.cliApellidos
              : "",
          correo:
            datosPagador && datosPagador.cliEmail ? datosPagador.cliEmail : "",
          direccion:
            datosPagador && datosPagador.cliDireccion
              ? datosPagador.cliDireccion
              : "",
          celular:
            datosPagador && datosPagador.cliCelular
              ? datosPagador.cliCelular
              : "",
          codEstadoCivil:
            datosPagador && datosPagador.cliCodigoEstadoCivil
              ? datosPagador.cliCodigoEstadoCivil
              : "",
          codGenero:
            datosPagador && datosPagador.cliCodGenero
              ? datosPagador.cliCodGenero
              : "",
          codProvincia:
            datosPagador && datosPagador.cliCodigoProvincia
              ? datosPagador.cliCodigoProvincia
              : "",
          codCiudad:
            datosPagador && datosPagador.cliCodigoCiudad
              ? datosPagador.cliCodigoCiudad
              : "",
          fechaNacimiento: firstDayOfMonth,
        },
        hasPersoneriaError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliPersoneria === null ||
              datosPagador.cliPersoneria === undefined
              ? true
              : false,
        hasCodTipoDocError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliCodigoTipoDocumento === null ||
              datosPagador.cliCodigoTipoDocumento === undefined
              ? true
              : false,
        hasCedulaError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliIdentificacion === null ||
              datosPagador.cliIdentificacion === undefined
              ? true
              : false,
        hasNombreError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliNombres === null ||
              datosPagador.cliNombres === undefined
              ? true
              : false,
        hasApellidoError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliApellidos === null ||
              datosPagador.cliApellidos === undefined
              ? true
              : false,
        hasCorreoError:
          this.state.datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliEmail === null ||
              datosPagador.cliEmail === undefined
              ? true
              : false,
        hasDireccionError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliDireccion === null ||
              datosPagador.cliDireccion === undefined
              ? true
              : false,
        hasCelularError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliCelular === null ||
              datosPagador.cliCelular === undefined
              ? true
              : false,
        hasECivilError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliCodigoEstadoCivil === null ||
              datosPagador.cliCodigoEstadoCivil === undefined
              ? true
              : false,
        hasGeneroError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliCodGenero === null ||
              datosPagador.cliCodGenero === undefined
              ? true
              : false,
        hasProvinciaError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliCodigoProvincia === null ||
              datosPagador.cliCodigoProvincia === undefined ||
              datosPagador.cliCodigoProvincia === ""
              ? true
              : false,
        hasCiudadError:
          datosPagador === "" || datosPagador === undefined
            ? true
            : datosPagador.cliCodigoCiudad === null ||
              datosPagador.cliCodigoCiudad === undefined ||
              datosPagador.cliCodigoCiudad === ""
              ? true
              : false,
      });
      //console.log("RES VALIDACION ", datosPagador === "" || datosPagador === undefined ? true : datosPagador.cliEmail === null || datosPagador.cliEmail === undefined ? true : false)
      this.props.onChangeProvincia(datosPagador.cliCodigoProvincia);
    }

    if (
      this.props.datosCotizacion.datosFacturacion !==
      prevProps.datosCotizacion.datosFacturacion
    ) {
      var today = new Date();
      var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      if (
        this.props.datosCotizacion.datosFacturacion !== "" &&
        this.props.datosCotizacion.datosFacturacion !== undefined &&
        this.props.datosCotizacion.datosFacturacion !== null
      ) {
        if (
          this.props.datosCotizacion.datosFacturacion.cliFechaNacimiento !==
          "" &&
          this.props.datosCotizacion.datosFacturacion.cliFechaNacimiento !==
          undefined &&
          this.props.datosCotizacion.datosFacturacion.cliFechaNacimiento !==
          null
        ) {
          let fechaNacimiento = this.props.datosCotizacion.datosFacturacion
            .cliFechaNacimiento;
          if (fechaNacimiento !== undefined) {
            //console.log("NACIMIENTO antes", fechaNacimiento)
            fechaNacimiento = fechaNacimiento.split("/", 3);

            firstDayOfMonth = new Date(
              fechaNacimiento[2],
              parseInt(fechaNacimiento[1]) - 1,
              fechaNacimiento[0]
            );
            //console.log("NACIMIENTO ", firstDayOfMonth)
          } else {
            //console.log("NACIMIENTO UNDEFINED", fechaNacimiento, firstDayOfMonth)
          }
        } else {
          //console.log("NACIMIENTO null", firstDayOfMonth)
        }

        //const anio=
      } else {
        //console.log("NACIMIENTO datosPagoadr", firstDayOfMonth)
      }
      //console.log("imprimiendo fecha ", firstDayOfMonth)
      this.setState({
        datosFacturacion: {
          cliPersoneria:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliPersoneria,
          codTipodocumento:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion
                .cliCodigoTipoDocumento,
          cedula:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliIdentificacion,
          cliNombres:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliNombres,
          cliApellidos:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliApellidos,
          correo:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliEmail,
          direccion:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliDireccion,
          celular:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliCelular,
          codEstadoCivil:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? null
              : this.props.datosCotizacion.datosFacturacion
                .cliCodigoEstadoCivil === null ||
                this.props.datosCotizacion.datosFacturacion
                  .cliCodigoEstadoCivil === undefined
                ? ""
                : this.props.datosCotizacion.datosFacturacion
                  .cliCodigoEstadoCivil,
          codGenero:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliCodGenero ===
                null ||
                this.props.datosCotizacion.datosFacturacion.cliCodGenero ===
                undefined
                ? ""
                : this.props.datosCotizacion.datosFacturacion.cliCodGenero,
          codProvincia:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion
                .cliCodigoProvincia === null ||
                this.props.datosCotizacion.datosFacturacion
                  .cliCodigoProvincia === undefined
                ? ""
                : this.props.datosCotizacion.datosFacturacion.cliCodigoProvincia,
          codCiudad:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? ""
              : this.props.datosCotizacion.datosFacturacion.cliCodigoCiudad ===
                null ||
                this.props.datosCotizacion.datosFacturacion.cliCodigoCiudad ===
                undefined
                ? ""
                : this.props.datosCotizacion.datosFacturacion.cliCodigoCiudad,
          fechaNacimiento:
            this.props.datosCotizacion.datosFacturacion === "" ||
              this.props.datosCotizacion.datosFacturacion === undefined
              ? firstDayOfMonth
              : firstDayOfMonth,
        },

        hasPersoneriaFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliPersoneria ===
              null ||
              this.props.datosCotizacion.datosFacturacion.cliPersoneria ===
              undefined
              ? true
              : false,
        hasCodTipoDocFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion
              .cliCodigoTipoDocumento === null ||
              this.props.datosCotizacion.datosFacturacion
                .cliCodigoTipoDocumento === undefined
              ? true
              : false,
        hasCedulaFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliIdentificacion ===
              null ||
              this.props.datosCotizacion.datosFacturacion.cliIdentificacion ===
              undefined
              ? true
              : false,
        hasNombreFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliNombres === null ||
              this.props.datosCotizacion.datosFacturacion.cliNombres ===
              undefined
              ? true
              : false,
        hasApellidoFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliApellidos ===
              null ||
              this.props.datosCotizacion.datosFacturacion.cliApellidos ===
              undefined
              ? true
              : false,
        hasCorreoFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliEmail === null ||
              this.props.datosCotizacion.datosFacturacion.cliEmail === undefined
              ? true
              : false,
        hasDireccionFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliDireccion ===
              null ||
              this.props.datosCotizacion.datosFacturacion.cliDireccion ===
              undefined
              ? true
              : false,
        hasCelularFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliCelular === null ||
              this.props.datosCotizacion.datosFacturacion.cliCelular ===
              undefined
              ? true
              : false,
        hasECivilFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion
              .cliCodigoEstadoCivil === null ||
              this.props.datosCotizacion.datosFacturacion
                .cliCodigoEstadoCivil === undefined
              ? true
              : false,
        hasGeneroFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliCodGenero ===
              null ||
              this.props.datosCotizacion.datosFacturacion.cliCodGenero ===
              undefined
              ? true
              : false,
        hasProvinciaFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliCodigoProvincia ===
              null ||
              this.props.datosCotizacion.datosFacturacion.cliCodigoProvincia ===
              undefined ||
              this.props.datosCotizacion.datosFacturacion.cliCodigoProvincia ===
              ""
              ? true
              : false,
        hasCiudadFError:
          this.props.datosCotizacion.datosFacturacion === "" ||
            this.props.datosCotizacion.datosFacturacion === undefined
            ? true
            : this.props.datosCotizacion.datosFacturacion.cliCodigoCiudad ===
              null ||
              this.props.datosCotizacion.datosFacturacion.cliCodigoCiudad ===
              undefined ||
              this.props.datosCotizacion.datosFacturacion.cliCodigoCiudad === ""
              ? true
              : false,
      });
      //console.log("RES VALIDACION ", this.props.datosCotizacion.datosFacturacion === "" || this.props.datosCotizacion.datosFacturacion === undefined ? true : this.props.datosCotizacion.datosFacturacion.cliEmail === null || this.props.datosCotizacion.datosFacturacion.cliEmail === undefined ? true : false)
      this.props.onChangeProvincia(
        this.props.datosCotizacion.datosFacturacion.cliCodigoProvincia
      );
    }
  }

  cambiarStringaFecha = (valor) => {
    if (typeof valor === "string") {
      let fecha = valor.split("/", 3);
      return new Date(fecha[2], parseInt(fecha[1]) - 1, fecha[0]);
    }
    return valor;
  };

  render() {
    let {
      mismosDatos,
      datosPagador,
      datosFacturacion,
      validate,
      esPasaporte,
      esPasaporteF,
      hasProvinciaError,
      hasCiudadError,
      hasProvinciaFError,
      hasCiudadFError,
      personeriaFacturacionSeleccionadoUsuario,
      personeriaContratanteSeleccionadoUsuario,
      mostrarPersoneria,
      mostrarPersoneriaF
    } = this.state;

    if (datosPagador === undefined) {
      datosPagador = {
        cliPersoneria: "1",
        codTipodocumento: infoIds.codigoCedulaStr,
        cedula: "",
        cliNombre1: "",
        cliNombre2: "",
        cliApellido1: "",
        cliApellido2: "",
        correo: "",
        direccion: "",
        celular: "",
        codEstadoCivil: null,
        codGenero: null,
      };
    }
    if (datosFacturacion === undefined) {
      datosFacturacion = {
        cliPersoneria: "1",
        codTipodocumento: infoIds.codigoCedulaStr,
        cedula: "",
        cliNombre1: "",
        cliNombre2: "",
        cliApellido1: "",
        cliApellido2: "",
        correo: "",
        direccion: "",
        celular: "",
        codEstadoCivil: null,
        codGenero: null,
      };
    }

    if (datosPagador.fechaNacimiento)
      datosPagador.fechaNacimiento = this.cambiarStringaFecha(
        datosPagador.fechaNacimiento
      );
    if (datosFacturacion.fechaNacimiento)
      datosFacturacion.fechaNacimiento = this.cambiarStringaFecha(
        datosFacturacion.fechaNacimiento
      );
    if (datosPagador.fechaCaducidadPasaporte)
      datosPagador.fechaCaducidadPasaporte = this.cambiarStringaFecha(
        datosPagador.fechaCaducidadPasaporte
      );
    if (datosPagador.fechaEmisionPasaporte)
      datosPagador.fechaEmisionPasaporte = this.cambiarStringaFecha(
        datosPagador.fechaEmisionPasaporte
      );
    if (datosPagador.fechaIngresoPais)
      datosPagador.fechaIngresoPais = this.cambiarStringaFecha(
        datosPagador.fechaIngresoPais
      );

    //Agregado para el caso de ruc
    let personeriacargaContratante = datosPagador.cliPersoneria;
    if (personeriaContratanteSeleccionadoUsuario !== "") {
      personeriacargaContratante = personeriaContratanteSeleccionadoUsuario;
    }

    let personeriacargaFacturacion = datosFacturacion.cliPersoneria;
    if (personeriaFacturacionSeleccionadoUsuario !== "") {
      personeriacargaFacturacion = personeriaFacturacionSeleccionadoUsuario;
    }

    return (
      // <form onSubmit={this.validateForm}>

      <Page
        title="Cotización de vehículos"
        breadcrumbs={[{ name: "cotización de vehículos", active: true }]}
      >
        <Row>
          <Col lg={8} md={12} sm={12} xs={12}>
            <div class="container-step">
              <div class="wrapper-step">
                <div class="arrow-steps clearfix-step">
                  <div class="step"> {` 1. Cotización `} </div>
                  <div class="step"> {` 2. Resumen `} </div>
                  <div class="step current"> {` 3. Confirmación `} </div>
                  <div class="step"> {` 4. Forma de Pago `} </div>
                  <div class="step"> {` 5. Formulario de Vinculación `} </div>
                  <div class="step"> {` 6. Emisión `} </div>

                  {this.props.dataUsuario.usu_tipo_usuario === "cliente" && (
                    <div class="step"> {` 4. Pago `} </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            lg={8}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >
            <Card className="flex-row ">
              <CardBody>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Button
                      className={"button-white"}
                      onClick={this.onClickRegresar}
                    >
                      <i class="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                      REGRESAR A RESUMEN
                    </Button>
                  </Col>
                </Row>

                <h3>{`Cotización # ${this.props.datosCarrito.productosCarrito.carContadorCarrito}`}</h3>
                <p />

                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h4 style={{ fontWeight: "bold" }}>
                      Datos del Contratante
                    </h4>
                    <p />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <div>(*) Campos Requeridos</div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Seleccione tipo de documento(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Select1
                      tabIndex="6" // Optional.[String or Number].Default: none.
                      id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                      name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                      value={datosPagador.codTipodocumento} // Optional.[String].Default: "".
                      validate={validate}
                      optionList={this.getTipoDocumentos(
                        datosPagador.cliPersoneria
                      )} // Required.[Array of Object(s)].Default: [].
                      onChange={(tipo, e) => {
                        datosPagador.codTipodocumento = tipo;
                        //console.log("datosPagador.codTipodocumento= ", datosPagador.codTipodocumento)
                        if (datosPagador.codTipodocumento === infoIds.codigoPasaporteStr) {
                          datosPagador.cliPersoneria = "1"
                          this.setState({
                            esPasaporte: true,
                            esruc: false,
                            mostrarPersoneria: false,
                            datosPagador
                          });
                        } else if (datosPagador.codTipodocumento === infoIds.codigoRucStr) {
                          datosPagador.cliPersoneria = "2"
                          this.setState({
                            esruc: true,
                            esPasaporte: false,
                            mostrarPersoneria: true,
                            datosPagador
                          });
                        } else {
                          datosPagador.cliPersoneria = "1"
                          this.setState({
                            esruc: false,
                            esPasaporte: false,
                            mostrarPersoneria: false,
                            datosPagador
                          });
                        }
                        this.setState({
                          datosPagador,
                          personeriaContratanteSeleccionadoUsuario:
                            datosPagador.cliPersoneria, //Agregado para caso de ruc
                        });
                        //console.log(e);
                      }} // Optional.[Func].Default: () => {}. Will return the value.
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasCodTipoDocError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione el tipo de documento",
                      }}
                    />
                  </Col>
                </Row>

                {mostrarPersoneria &&
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Seleccione personería(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                        name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                        value={datosPagador.cliPersoneria} // Optional.[String].Default: "".
                        validate={validate}
                        optionList={listadoPersoneria} // Required.[Array of Object(s)].Default: [].
                        onChange={(personeria, e) => {
                          if (datosPagador.cliPersoneria !== personeria) {
                            datosPagador.cliPersoneria = personeria;
                            //datosPagador.codTipodocumento = 0;
                            this.setState({
                              datosPagador,
                              //esPasaporte: false,                              
                            });
                          }
                          //console.log(e);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasPersoneriaError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione la personería",
                        }}
                      />
                    </Col>
                  </Row>

                }



                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Número de Identificación (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="text"
                      id="test"
                      name="test"
                      classNameInput={"form-control"}
                      value={datosPagador.cedula}
                      validate={validate}
                      onChange={(identificacion, e) => {
                        datosPagador.cedula = identificacion;
                        this.setState({
                          datosPagador,
                        });
                        if (
                          this.state.esruc &&
                          identificacion.length === 13 &&
                          datosPagador.codTipodocumento === infoIds.codigoRucStr
                        ) {
                          this.props.consultaCargarDatos({
                            cedula: identificacion,
                            tipo: 1,
                            personeria: datosPagador.cliPersoneria
                          });
                        } else if (
                          !this.state.esruc &&
                          identificacion.length === 10 &&
                          datosPagador.codTipodocumento === infoIds.codigoCedulaStr
                        ) {
                          this.props.consultaCargarDatos({
                            cedula: identificacion,
                            tipo: 1,
                            personeria: datosPagador.cliPersoneria
                          });
                        }
                      }}
                      onBlur={(e) => {
                        //console.log(e);
                      }}
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasCedulaError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        //name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        reg: this.state.esruc
                          ? /^\d{13}$/
                          : this.state.esPasaporte
                            ? ""
                            : /^\d{10}$/,
                        msgOnError:
                          "Por favor ingrese la identificación correctamente",
                      }}
                    />
                  </Col>
                </Row>

                {esPasaporte === true && (
                  <div>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Fecha Expedición Pasaporte (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <DatePicker
                          {...this.props}
                          dateFormat="dd/MM/yyyy"
                          isClearable={true}
                          selected={
                            typeof datosPagador.fechaEmisionPasaporte ===
                              "string"
                              ? new Date(datosPagador.fechaEmisionPasaporte)
                              : datosPagador.fechaEmisionPasaporte
                          }
                          onChange={this.handleChangeFechaExpedicionPasaporte}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          ref={(node) => {
                            this.ref = node;
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Fecha Vencimiento Pasaporte (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <DatePicker
                          {...this.props}
                          dateFormat="dd/MM/yyyy"
                          isClearable={true}
                          selected={
                            typeof datosPagador.fechaCaducidadPasaporte ===
                              "string"
                              ? new Date(datosPagador.fechaCaducidadPasaporte)
                              : datosPagador.fechaCaducidadPasaporte
                          }
                          onChange={this.handleChangeFechaVencimientoPasaporte}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          ref={(node) => {
                            this.ref = node;
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Fecha Ingreso al País (*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <DatePicker
                          {...this.props}
                          dateFormat="dd/MM/yyyy"
                          isClearable={true}
                          selected={
                            typeof datosPagador.fechaIngresoPais === "string"
                              ? new Date(datosPagador.fechaIngresoPais)
                              : datosPagador.fechaIngresoPais
                          }
                          onChange={this.handleChangeFechaIngresoPais}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          ref={(node) => {
                            this.ref = node;
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                )}

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>
                      {datosPagador.codTipodocumento !== infoIds.codigoRucStr
                        ? "Nombres (*)"
                        : "Razón Social (*)"}
                    </h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="test"
                      name="test"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={`${datosPagador.cliNombres}`}
                      onChange={(nombres, e) => {
                        datosPagador.cliNombres = nombres;
                        this.setState({
                          datosPagador,
                        });
                        //console.log('onchange,', nombres);
                      }}
                      onBlur={(e) => {
                        //console.log(e);
                      }}
                      validationCallback={(res) => {
                        //console.log('callback', res);
                        this.setState({
                          hasNombreError: res,
                          validate: false,
                        });
                      }}
                      validationOption={{
                        // name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        //  check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        reg:
                          datosPagador.codTipodocumento !== infoIds.codigoRucStr
                            ? /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/
                            : expresionesRegulares.razonSocial,
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError:
                          "Por favor ingrese los nombres, No deben tener caracteres especiales",
                      }}
                    />
                  </Col>
                </Row>

                <Row
                  style={
                    datosPagador.codTipodocumento !== infoIds.codigoRucStr
                      ? {}
                      : { display: "none" }
                  }
                >
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Apellidos (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="test"
                      name="test"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={`${datosPagador.cliApellidos}`}
                      onChange={(apellidos, e) => {
                        datosPagador.cliApellidos = apellidos;
                        this.setState({
                          datosPagador,
                        });
                      }}
                      onBlur={(e) => {
                        //console.log(e);
                      }}
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasApellidoError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        //name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        //check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                        msgOnError:
                          "Por favor ingrese los apellidos, No deben tener caracteres especiales",
                      }}
                    />
                  </Col>
                </Row>

                <Row
                  style={
                    datosPagador.codTipodocumento !== infoIds.codigoRucStr
                      ? {}
                      : { display: "none" }
                  }
                >
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Estado Civil(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Select1
                      tabIndex="6" // Optional.[String or Number].Default: none.
                      id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                      name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                      value={datosPagador.codEstadoCivil} // Optional.[String].Default: "".
                      optionList={this.props.catalogos.estadosCiviles} // Required.[Array of Object(s)].Default: [].
                      validate={validate}
                      onChange={(ecivil, e) => {
                        datosPagador.codEstadoCivil = ecivil;
                        this.setState({
                          datosPagador,
                        });
                        //console.log(e);
                      }} // Optional.[Func].Default: () => {}. Will return the value.
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasECivilError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione su estado civil",
                      }}
                    />
                  </Col>
                </Row>

                <Row
                  style={
                    datosPagador.codTipodocumento !== infoIds.codigoRucStr
                      ? {}
                      : { display: "none" }
                  }
                >
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Género(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Select1
                      tabIndex="6" // Optional.[String or Number].Default: none.
                      id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                      name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                      value={datosPagador.codGenero} // Optional.[String].Default: "".
                      optionList={this.props.catalogos.generos} // Required.[Array of Object(s)].Default: [].
                      validate={validate}
                      onChange={(genero, e) => {
                        datosPagador.codGenero = genero;
                        this.setState({
                          datosPagador,
                        });
                        //console.log(e);
                      }} // Optional.[Func].Default: () => {}. Will return the value.
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasGeneroError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione el género",
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <div style={{ display: "none" }}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                        name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                        value={datosPagador.codProvincia} // Optional.[String].Default: "".
                        optionList={this.props.catalogos.provincias} // Required.[Array of Object(s)].Default: [].
                        validate={validate}
                        onChange={(provincia, e) => {
                          datosPagador.codProvincia = provincia;
                          this.setState({
                            datosPagador,
                          });
                          this.props.onChangeProvincia(provincia);
                          //console.log(e);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{
                          maxHeight: "200px",
                          overflow: "auto",
                          fontSize: "14px",
                        }} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasProvinciaError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione la provincia",
                        }}
                      />
                    </div>
                    <Select
                      value={
                        datosPagador.codProvincia2
                          ? datosPagador.codProvincia2
                          : null
                      }
                      components={makeAnimated()}
                      onChange={(provincia, e) => {
                        datosPagador.codProvincia = provincia.value.toString();
                        datosPagador.codProvincia2 = provincia;
                        datosPagador.codCiudad2 = null;
                        this.setState({
                          datosPagador,
                          hasProvinciaError: false,
                        });
                        this.props.onChangeProvincia(
                          provincia.value.toString()
                        );
                        //console.log("datosPagador",datosPagador);
                      }}
                      options={this.props.catalogos.provinciasSelect}
                      isSearchable={true}
                      placeholder={"Seleccione una provincia"}
                      isMulti={false}
                    />
                    {(datosPagador.codProvincia2 === undefined ||
                      datosPagador.codProvincia2 === null ||
                      datosPagador.codProvincia2.length === 0) && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          Por favor seleccione una provincia
                        </span>
                      )}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <div style={{ display: "none" }}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                        name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                        value={datosPagador.codCiudad} // Optional.[String].Default: "".
                        optionList={this.props.catalogos.ciudades} // Required.[Array of Object(s)].Default: [].
                        validate={validate}
                        onChange={(ciudad, e) => {
                          datosPagador.codCiudad = ciudad;
                          this.setState({
                            datosPagador,
                            hasCiudadFError: false,
                          });
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{
                          maxHeight: "200px",
                          overflow: "auto",
                          fontSize: "14px",
                        }} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasCiudadError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione la ciudad",
                        }}
                      />
                    </div>
                    <Select
                      value={
                        datosPagador.codCiudad2 ? datosPagador.codCiudad2 : null
                      }
                      components={makeAnimated()}
                      onChange={(ciudad, e) => {
                        datosPagador.codCiudad = ciudad && ciudad.value ? ciudad.value.toString(): '';
                        datosPagador.codCiudad2 = ciudad;
                        this.setState({
                          datosPagador,
                          hasCiudadError: false,
                        });
                        //console.log("datosPagador",datosPagador);
                      }}
                      options={this.props.catalogos.ciudadesSelect}
                      isSearchable={true}
                      placeholder={"Seleccione una ciudad"}
                      isMulti={false}
                    />
                    {(datosPagador.codCiudad2 === undefined ||
                      datosPagador.codCiudad2 === null ||
                      datosPagador.codCiudad2.length === 0) && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          Por favor seleccione una ciudad
                        </span>
                      )}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>
                      {datosPagador.codTipodocumento !== infoIds.codigoRucStr
                        ? "Fecha nacimiento(*)"
                        : "Fecha de Constitución (*)"}
                    </h5>
                  </Col>
                  {console.log('datosFecha', datosPagador.fechaNacimiento)}
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {console.log("FECHA: ", datosPagador.fechaNacimiento)}
                    <DatePicker
                      {...this.props}
                      dateFormat="dd/MM/yyyy"
                      isClearable={true}
                      selected={
                        // typeof datosPagador.fechaNacimiento === "string" &&
                        //   ? moment(datosPagador.fechaNacimiento,'DD/MM/yyyy')
                        //   : datosPagador.fechaNacimiento
                        // datosPagador.fechaNacimiento
                        // new Date()
                        isFechaValidaStr(datosPagador.fechaNacimiento)
                      }
                      onChange={this.handleChangeDate}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="form-control"
                      ref={(node) => {
                        this.ref = node;
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="text"
                      id="correo"
                      name="correo"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={`${datosPagador.correo}`}
                      onChange={(correo, e) => {
                        datosPagador.correo = correo;
                        this.setState({
                          datosPagador,
                        });
                        //console.log(e);
                      }}
                      onBlur={(e) => {
                        //console.log(e);
                      }}
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasCorreoError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        reg: expresionesRegulares.email,
                        msgOnError:
                          "Por favor ingrese el correo electrónico en minúsculas",
                      }}
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textarea
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="direccion1"
                      name="direccion1"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={datosPagador.direccion}
                      onChange={(direccion, e) => {

                      if(this.state.mismosDatos){
                        datosFacturacion.direccion = direccion

                        this.setState({
                          datosFacturacion,
                        });
                      }
                        datosPagador.direccion = direccion;
                        this.setState({
                          datosPagador,
                        });
                        //console.log(e);
                      }}
                      onBlur={(e) => {
                        //console.log(e);
                      }}
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasDireccionError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        name: "direccion1", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        reg: expresionesRegulares.stringSinCaracteresEspeciales,
                        msgOnError: `Por favor ingrese la dirección, No deben tener caracteres especiales`,
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Textbox
                      ref={this.textInput}
                      tabIndex="1"
                      type="text"
                      id="celular"
                      name="celular"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={datosPagador.celular}
                      onChange={(celular, e) => {
                        datosPagador.celular = celular;
                        this.setState({
                          datosPagador,
                        });

                        //console.log(e);
                      }}
                      onBlur={(e) => {
                        //console.log(e);
                      }}
                      validationCallback={(res) =>
                        //console.log(res)
                        this.setState({
                          hasCelularError: res,
                          validate: false,
                        })
                      }
                      validationOption={{
                        name: "celular", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        reg: /^\d{10}$/,
                        msgOnError: "Por favor ingrese solo números",
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Checkbox
                      id={"agreement"} // Optional.[String].Default: "".  Input ID.
                      name={"agreement"} // Optional.[String].Default: "". Input name
                      value={mismosDatos} // Required.[String].Default: "".
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      checked={mismosDatos} // Required.[Bool].Default: false.
                      labelHtml={
                        <div style={{ paddingTop: "0.5em" }}>
                          <h5>
                            Utilizar los mismos datos para pago y facturación
                          </h5>
                        </div>
                      }
                      onChange={(mismosDatos, e) => {
                        this.setState({
                          mismosDatos,
                        });
                        if (mismosDatos) {
                          datosFacturacion = datosPagador;
                          this.setState({
                            datosFacturacion,
                            hasPersoneriaFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliPersoneria === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliPersoneria === undefined
                                  ? true
                                  : false,
                            hasCodTipoDocFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliCodigoTipoDocumento === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliCodigoTipoDocumento === undefined
                                  ? true
                                  : false,
                            hasCedulaFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliIdentificacion === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliIdentificacion === undefined
                                  ? true
                                  : false,
                            hasNombreFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliNombres === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliNombres === undefined
                                  ? true
                                  : false,
                            hasApellidoFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliApellidos === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliApellidos === undefined
                                  ? true
                                  : false,
                            hasCorreoFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliEmail === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliEmail === undefined
                                  ? true
                                  : false,
                            hasDireccionFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliDireccion === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliDireccion === undefined
                                  ? true
                                  : false,
                            hasCelularFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliCelular === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliCelular === undefined
                                  ? true
                                  : false,
                            hasECivilFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliCodigoEstadoCivil === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliCodigoEstadoCivil === undefined
                                  ? true
                                  : false,
                            hasGeneroFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliCodGenero === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliCodGenero === undefined
                                  ? true
                                  : false,
                            hasProvinciaFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliCodigoProvincia === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliCodigoProvincia === undefined
                                  ? true
                                  : false,
                            hasCiudadFError:
                              this.props.datosCotizacion.datosPagador === "" ||
                                this.props.datosCotizacion.datosPagador ===
                                undefined
                                ? true
                                : this.props.datosCotizacion.datosPagador
                                  .cliCodigoCiudad === null ||
                                  this.props.datosCotizacion.datosPagador
                                    .cliCodigoCiudad === undefined
                                  ? true
                                  : false,
                          });
                          //set ismosdatos a deatosFacturacio
                        } else {
                          //console.log("mismos datos falsos")
                          datosFacturacion = {
                            cedula: "",
                            cliNombres: "",
                            cliApellidos: "",
                            correo: "",
                            direccion: "",
                            celular: "",
                            cliPersoneria: 0,
                            codTipodocumento: 0,
                            codEstadoCivil: "",
                            codGenero: "",
                            codProvincia: "",
                            codCiudad: "",
                          };
                          this.setState({
                            datosFacturacion,
                            hasPersoneriaFError: true,
                            hasCodTipoDocFError: true,
                            hasCedulaFError: true,
                            hasNombreFError: true,
                            hasApellidoFError: true,
                            hasCorreoFError: true,
                            hasDireccionFError: true,
                            hasCelularFError: true,
                            hasECivilFError: true,
                            hasGeneroFError: true,
                            hasProvinciaFError: true,
                            hasCiudadFError: true,
                          });
                        }
                        //console.log(e);
                      }} // Required.[Func].Default: () => {}. Will return the value.
                      validationOption={{
                        name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>

          </Col>
          
          <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
            <ValoresCotizacion
              formEditado={false}
              paso={"confirmacion-cotizacion"}
              metodo={this.validateForm}
              valorTotal={this.props.datosCarrito.productosCarrito.valorTotal}
              desactivarBoton={
                this.state.desactivarBoton
              }
            >

              {this.props.datosListaNegra.inListaNegra
                ?
                <div style={{marginTop:'10px'}}>
                  <Alert color="danger">
                    <center><p>{this.props.datosListaNegra.inListaNegraMensaje}</p></center>
                  </Alert>
                </div>
                :
                null
              }

              {this.props.datosListaNegra.listaNegraError &&
                <Alert color="danger">
                  <center><p>{ErrorMsgConstants.errorServicioListaNegra}</p></center>
                </Alert>
              }
            </ValoresCotizacion>
          </Col>
        </Row>

        {!mismosDatos && (
          <Row>
            <Col
              lg={8}
              md={12}
              sm={12}
              xs={12}
              className="detalle-cotizacion-box"
            >
              <Card className="flex-row ">
                <CardBody>
                  <Row>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <h4 style={{ fontWeight: "bold" }}>
                        Datos de Facturación
                      </h4>
                      <p />
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <div>(*) Campos Requeridos</div>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Seleccione tipo de documento(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                        name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                        value={datosFacturacion.codTipodocumento} // Optional.[String].Default: "".
                        optionList={this.getTipoDocumentos(
                          datosFacturacion.cliPersoneria
                        )} // Required.[Array of Object(s)].Default: [].
                        onChange={(tipo, e) => {
                          datosFacturacion.codTipodocumento = tipo;
                          //console.log("datosPagador.codTipodocumentoDF= ", datosFacturacion.codTipodocumento)
                          if (datosFacturacion.codTipodocumento === infoIds.codigoPasaporteStr) {
                            datosFacturacion.cliPersoneria = "1"
                            this.setState({
                              esPasaporteF: true,
                              mostrarPersoneriaF: false,
                              esrucf: false,
                              hasPersoneriaFError: false,
                              datosFacturacion
                            });
                          } else if (
                            datosFacturacion.codTipodocumento === infoIds.codigoRucStr
                          ) {
                            datosFacturacion.cliPersoneria = "2"
                            this.setState({
                              esrucf: true,
                              esPasaporteF: false,
                              mostrarPersoneriaF: true,
                              datosFacturacion
                            });
                          } else {
                            datosFacturacion.cliPersoneria = "1"
                            this.setState({
                              esrucf: false,
                              esPasaporteF: false,
                              mostrarPersoneriaF: false,
                              datosFacturacion
                            });
                          }
                          this.setState({
                            datosFacturacion,
                            personeriaFacturacionSeleccionadoUsuario:
                              datosFacturacion.cliPersoneria, //Agregado para caso de ruc
                          });
                          //console.log(e);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasCodTipoDocFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError:
                            "Por favor seleccione el tipo de documento",
                        }}
                      />
                    </Col>
                  </Row>

                  {mostrarPersoneriaF &&
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Seleccione personería(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <Select1
                          tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                          name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                          value={datosFacturacion.cliPersoneria} // Optional.[String].Default: "".
                          optionList={listadoPersoneria} // Required.[Array of Object(s)].Default: [].
                          onChange={(personeria, e) => {
                            if (datosFacturacion.cliPersoneria !== personeria) {
                              datosFacturacion.cliPersoneria = personeria;
                              //datosFacturacion.codTipodocumento = 0;
                              this.setState({
                                datosFacturacion,
                                //esPasaporteF: false,
                              });
                            }
                            //console.log(e);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationCallback={(res) =>
                            //console.log(res)
                            this.setState({
                              hasPersoneriaFError: res,
                              validate: false,
                            })
                          }
                          validationOption={{
                            name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione la personería",
                          }}
                        />
                      </Col>
                    </Row>
                  }





                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Número de Identificación (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={datosFacturacion.cedula}
                        onChange={(identificacion, e) => {
                          datosFacturacion.cedula = identificacion;
                          this.setState({
                            datosFacturacion,
                          });
                          if (
                            this.state.esrucf &&
                            identificacion.length === 13 &&
                            datosFacturacion.codTipodocumento === infoIds.codigoRucStr
                          ) {
                            this.props.consultaCargarDatos({
                              cedula: identificacion,
                              tipo: 2,
                              personeria: datosFacturacion.cliPersoneria
                            });
                          } else if (
                            identificacion.length === 10 &&
                            datosFacturacion.codTipodocumento === infoIds.codigoCedulaStr
                          ) {
                            this.props.consultaCargarDatos({
                              cedula: identificacion,
                              tipo: 2,
                              personeria: datosFacturacion.cliPersoneria
                            });
                          }
                          //console.log(e);
                        }}
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasCedulaFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor ingrese la identificación",
                        }}
                      />
                    </Col>
                  </Row>

                  {esPasaporteF === true && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Expedición Pasaporte (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            isClearable={true}
                            selected={
                              typeof datosFacturacion.fechaEmisionPasaporte ===
                                "string"
                                ? new Date(
                                  datosFacturacion.fechaEmisionPasaporte
                                )
                                : datosFacturacion.fechaEmisionPasaporte
                            }
                            onChange={
                              this.handleChangeFechaExpedicionPasaporteF
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Vencimiento Pasaporte (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            isClearable={true}
                            selected={
                              typeof datosFacturacion.fechaCaducidadPasaporte ===
                                "string"
                                ? new Date(
                                  datosFacturacion.fechaCaducidadPasaporte
                                )
                                : datosFacturacion.fechaCaducidadPasaporte
                            }
                            onChange={
                              this.handleChangeFechaVencimientoPasaporteF
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Ingreso al País (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            isClearable={true}
                            selected={
                              typeof datosFacturacion.fechaIngresoPais ===
                                "string"
                                ? new Date(datosFacturacion.fechaIngresoPais)
                                : datosFacturacion.fechaIngresoPais
                            }
                            onChange={this.handleChangeFechaIngresoPaisF}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}

                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>
                        {datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                          ? "Nombres (*)"
                          : "Razón Social (*)"}
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={`${datosFacturacion.cliNombres}`}
                        onChange={(nombres, e) => {
                          datosFacturacion.cliNombres = nombres;
                          this.setState({
                            datosFacturacion,
                          });
                          //console.log(e);
                        }}
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasNombreFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          reg:
                          datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                              ? /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/
                              : expresionesRegulares.razonSocial,
                          msgOnError:
                            "Por favor ingrese los nombres,sin caracteres especiales",
                        }}
                      />
                    </Col>
                  </Row>
                  <Row
                    style={
                      datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                        ? {}
                        : { display: "none" }
                    }
                  >
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Apellidos (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={`${datosFacturacion.cliApellidos}`}
                        onChange={(apellidos, e) => {
                          datosFacturacion.cliApellidos = apellidos;
                          this.setState({
                            datosFacturacion,
                          });
                          //console.log(e);
                        }}
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasApellidoFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          //name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required:
                            datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                              ? true
                              : false, // Optional.[Bool].Default: true. To determin if it is a required field.
                          reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                          msgOnError: "Por favor ingrese los apellidos",
                        }}
                      />
                    </Col>
                  </Row>

                  <Row
                    style={
                      datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                        ? {}
                        : { display: "none" }
                    }
                  >
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Estado Civil(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                        name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                        value={datosFacturacion.codEstadoCivil} // Optional.[String].Default: "".
                        optionList={this.props.catalogos.estadosCiviles} // Required.[Array of Object(s)].Default: [].
                        validate={validate}
                        onChange={(ecivil, e) => {
                          datosFacturacion.codEstadoCivil = ecivil;
                          this.setState({
                            datosFacturacion,
                          });
                          //console.log(e);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasECivilFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required:
                            datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                              ? true
                              : false, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione su estado civil",
                        }}
                      />
                    </Col>
                  </Row>

                  <Row
                    style={
                      datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                        ? {}
                        : { display: "none" }
                    }
                  >
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Género(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                        name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                        value={datosFacturacion.codGenero} // Optional.[String].Default: "".
                        optionList={this.props.catalogos.generos} // Required.[Array of Object(s)].Default: [].
                        validate={validate}
                        onChange={(genero, e) => {
                          datosFacturacion.codGenero = genero;
                          this.setState({
                            datosFacturacion,
                          });
                          //console.log(e);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasGeneroFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required:
                            datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                              ? true
                              : false, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione el género",
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Provincia(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <div style={{ display: "none" }}>
                        <Select1
                          tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                          name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                          value={datosFacturacion.codProvincia} // Optional.[String].Default: "".
                          optionList={this.props.catalogos.provincias} // Required.[Array of Object(s)].Default: [].
                          validate={validate}
                          onChange={(provincia, e) => {
                            datosFacturacion.codProvincia = provincia;
                            this.setState({
                              datosFacturacion,
                            });
                            this.props.onChangeProvincia(provincia);
                            //console.log(e);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{
                            maxHeight: "200px",
                            overflow: "auto",
                            fontSize: "14px",
                          }} // Optional.[Object].Default: {}.
                          validationCallback={(res) =>
                            //console.log(res)
                            this.setState({
                              hasProvinciaFError: res,
                              validate: false,
                            })
                          }
                          validationOption={{
                            name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione la provincia",
                          }}
                        />
                      </div>

                      <Select
                        value={
                          datosFacturacion.codProvincia2
                            ? datosFacturacion.codProvincia2
                            : null
                        }
                        components={makeAnimated()}
                        onChange={(provincia, e) => {
                          datosFacturacion.codProvincia = provincia.value.toString();
                          datosFacturacion.codProvincia2 = provincia;
                          datosFacturacion.codCiudad2 = null;
                          this.setState({
                            datosFacturacion,
                            hasProvinciaFError: false,
                          });
                          this.props.onChangeProvincia(
                            provincia.value.toString()
                          );
                          //console.log("datosFacturacion",datosFacturacion);
                        }}
                        options={this.props.catalogos.provinciasSelect}
                        isSearchable={true}
                        placeholder={"Seleccione una provincia"}
                        isMulti={false}
                      />
                      {(datosFacturacion.codProvincia2 === undefined ||
                        datosFacturacion.codProvincia2 === null ||
                        datosFacturacion.codProvincia2.length === 0) && (
                          <span style={{ color: "red", fontSize: "1rem" }}>
                            Por favor seleccione una provincia
                          </span>
                        )}
                    </Col>
                  </Row>

                  {datosFacturacion.codProvincia !== "" && (
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Ciudad(*)</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        <div style={{ display: "none" }}>
                          <Select1
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                            name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                            value={datosFacturacion.codCiudad} // Optional.[String].Default: "".
                            optionList={this.props.catalogos.ciudades} // Required.[Array of Object(s)].Default: [].
                            validate={validate}
                            onChange={(ciudad, e) => {
                              datosFacturacion.codCiudad = ciudad;
                              this.setState({
                                datosFacturacion,
                              });
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{
                              maxHeight: "200px",
                              overflow: "auto",
                              fontSize: "14px",
                            }} // Optional.[Object].Default: {}.
                            validationCallback={(res) =>
                              //console.log(res)
                              this.setState({
                                hasCiudadFError: res,
                                validate: false,
                              })
                            }
                            validationOption={{
                              name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione la ciudad",
                            }}
                          />
                        </div>

                        <Select
                          value={
                            datosFacturacion.codCiudad2
                              ? datosFacturacion.codCiudad2
                              : null
                          }
                          components={makeAnimated()}
                          onChange={(ciudad, e) => {
                            datosFacturacion.codCiudad = ciudad.value.toString();
                            datosFacturacion.codCiudad2 = ciudad;
                            this.setState({
                              datosFacturacion,
                              hasCiudadFError: false,
                            });
                            //console.log("datosFacturacion",datosFacturacion);
                          }}
                          options={this.props.catalogos.ciudadesSelect}
                          isSearchable={true}
                          placeholder={"Seleccione una ciudad"}
                          isMulti={false}
                        />
                        {(datosFacturacion.codCiudad2 === undefined ||
                          datosFacturacion.codCiudad2 === null ||
                          datosFacturacion.codCiudad2.length === 0) && (
                            <span style={{ color: "red", fontSize: "1rem" }}>
                              Por favor seleccione una ciudad
                            </span>
                          )}
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>
                        {datosFacturacion.codTipodocumento !== infoIds.codigoRucStr
                          ? "Fecha nacimiento(*)"
                          : "Fecha de Constitución(*)"}
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <DatePicker
                        {...this.props}
                        dateFormat="dd/MM/yyyy"
                        isClearable={true}
                        selected={datosFacturacion.fechaNacimiento}
                        onChange={this.handleChangeDateFacturacion}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control"
                        ref={(node) => {
                          this.ref = node;
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Correo Electrónico (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="correo"
                        name="correo"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={datosFacturacion.correo}
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        onChange={(email, e) => {
                          datosFacturacion.correo = email;
                          this.setState({
                            datosFacturacion,
                          });
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasCorreoFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "correo",
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          reg: expresionesRegulares.email,
                          msgOnError:
                            "Por favor ingrese el correo electrónico en minusculas",
                        }}
                      />
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Dirección (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textarea
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="direccion"
                        name="direccion"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={datosFacturacion.direccion}
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        onChange={(direccion, e) => {
                          datosFacturacion.direccion = direccion;
                          this.setState({
                            datosFacturacion,
                          });
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasDireccionFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor ingrese la dirección",
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Celular (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={datosFacturacion.celular}
                        onChange={(celular, e) => {
                          datosFacturacion.celular = celular;
                          this.setState({
                            datosFacturacion,
                          });
                          //console.log(e);
                        }}
                        onBlur={(e) => {
                          //console.log(e);
                        }}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasCelularFError: res,
                            validate: false,
                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          reg: /^\d{10}$/,
                          msgOnError: "Por favor ingrese solo números",
                        }}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>

            </Col>
          </Row>
        )}


      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  datosCotizacion: state.datosCotizacion,
  datosCarrito: state.dataProductoCarrito,
  catalogos: state.catalogosCotizacion,
  datosPago: state.datosPago,
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosListaNegra: state.datosListaNegra,
  datosValidacion: state.datosValidacionEmailIdentificacion,
  datosSucursales: state.datosSucursales,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setPagador: (datos) => dispatch(setDatosPagador(datos)),
    setFacturacion: (datos) => dispatch(setDatosFacturacion(datos)),
    guardarDatos: (datos) => dispatch(FetchGuardarDatosFacturacion(datos)),
    descargarCotizacion: (datos) => dispatch(FetchDescargarCotizacion(datos)),
    listarCarrito: (idCarrito) =>
      dispatch(FetchDataProductosCarrito(idCarrito)),
    checkInListaNegra: (identificacion, datos) => dispatch(estaEnListaNegra(identificacion, datos)),
    limpiarDatosListaNegra: () => dispatch(LimpiarListaNegra()),
    
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Cotizacion4Cotizacion)
);
